import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule } from '@core/components';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { QRCodeModule } from 'angularx-qrcode';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { DocumentDetailModule } from '../pages/document-detail/document-detail.module';
import { SharedModule } from '../shared/shared/shared.module';
import { DocumentKeyComponent } from './document-key/document-key.component';
import { SigningPageComponent } from './signing-page/signing-page.component';
import { SigningServiceHttp } from './signing-service';
import { SigningSidebarModule } from './signing-sidebar/signing-sidebar.module';
import { NorwegianBankIdBoxComponent } from './norwegian-bank-id-box/norwegian-bank-id-box/norwegian-bank-id-box.component';
import { EsignAndSmsPinComponent } from './esign-and-sms-pin/esign-and-sms-pin.component';
import { RequestPostponedComponent } from './request-postponed/request-postponed.component';
const appRoutes: Routes = [
    {
        path: '',
        component: SigningPageComponent,
        data: { signingArea: true, is_sender: 0 }
    },
]
@NgModule({
  declarations: [
    SigningPageComponent,
    DocumentKeyComponent,
    NorwegianBankIdBoxComponent,
    EsignAndSmsPinComponent,
    RequestPostponedComponent,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    ContentHeaderModule,
    NgbModule,
    NgSelectModule,
    ColorPickerModule,
    CoreTouchspinModule,
    CoreSidebarModule,
    DocumentDetailModule,
    SigningSidebarModule,
    QRCodeModule,
    SharedModule,
    TranslocoDirective,
    RouterModule.forChild(appRoutes)
  ],
  exports: [
  ],
  providers: [SigningServiceHttp]
})
export class SigningPagesModule {}
